// Package imports:
import React from 'react';
import cx from 'classnames';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft, faAngleRight } from '@fortawesome/pro-regular-svg-icons'
import { faArrowRightToBracket, faFile, faFileExcel, faFileImage, faFilePdf, faMailbox, faPhone, faPlus, faPrint, faDownload, faFileCsv, faFileWord, faFileZipper, faSearchPlus } from '@fortawesome/pro-solid-svg-icons';
// Define the available icon types for links and file representations
export type LinkIcons =
    'forward' |
    'back' |
    'pdf' |
    'excel' |
    'document' |
    'mail' |
    'phone' |
    'image' |
    'more' |
    'print' |
    'login' |
    'word' |
    'csv' |
    'zip' |
    'download' |
    'searchPlus' |
    'angleLeft' |
    'angleRight'
    ;

// Map each icon type to its corresponding FontAwesome icon definition
const iconMap: { [i in LinkIcons]: IconDefinition } = {
    'forward': faAngleRight,
    'back': faAngleLeft,
    'pdf': faFilePdf,
    'excel': faFileExcel,
    'word': faFileWord,
    'document': faFile,
    'mail': faMailbox,
    'phone': faPhone,
    'image': faFileImage,
    'csv': faFileCsv,
    'zip': faFileZipper,
    'download': faDownload,
    'more': faPlus,
    'print': faPrint,
    'login': faArrowRightToBracket,
    'searchPlus': faSearchPlus,
    'angleLeft': faAngleLeft,
    'angleRight': faAngleRight
};

type AnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;
type LinkSize = '12' | '13' | '14' | '15' | '16' | '18' | '20' | '24';
interface IProps {
    url?: string,
    disabled?: boolean,
    targetBlank?: boolean,
    wrapTextForMobile?: boolean,
    splitLines?: boolean,
    linkSize?: LinkSize,
    icon?: LinkIcons
}

type Props = AnchorProps & IProps;

const Link: React.FC<Props> = ({
    url,
    children,
    disabled,
    targetBlank,
    wrapTextForMobile,
    splitLines,
    linkSize = '15',
    icon,
    className,
    ...props
}) => {
    return (
        <a
            className={cx(
                "KCL_link",
                className,
                `font-size--${linkSize}`,
                { 'is-disabled': disabled },
                { 'wrap-text-for-mobile': wrapTextForMobile },
                { 'split-lines': splitLines }
            )}
            href={url}
            target={targetBlank ? '_blank' : '_self'}
            rel='noreferrer'
            {...props}
        >
            {icon &&
                <FontAwesomeIcon
                    icon={iconMap[icon]}
                    className={cx("icon-fa", {
                        'arrow-icon': icon === 'forward' || icon === 'back'
                    })}
                />
            }
            {children}
        </a >
    );
}

export default Link;